import {
  RangeSectionScale,
  RangeAggregationHistogram,
  RangeAggregationBucket,
} from '../../../../../../types';

export const getHistogramScale = (
  histogram: RangeAggregationHistogram | undefined
): RangeSectionScale => histogram?.scale || 'linear';

const getHistogramStart = (histogram: RangeAggregationHistogram): number => {
  if (histogram.buckets.length === 0) {
    return 0;
  }

  const scale = getHistogramScale(histogram);
  const start = histogram.buckets[0].from;

  switch (scale) {
    case 'log2':
    case 'log10':
      // For logarithmic scales, we'll round the start value down to make it presentable.
      return Math.floor(start);
    default:
      return start;
  }
};

const getHistogramEnd = (histogram: RangeAggregationHistogram): number => {
  if (histogram.buckets.length === 0) {
    return 0;
  }

  const scale = getHistogramScale(histogram);
  const end = histogram.buckets[histogram.buckets.length - 1].to;

  switch (scale) {
    case 'log2':
    case 'log10':
      // For logarithmic scales, we'll round the end value up to make it presentable.
      return Math.ceil(end);
    default:
      return end;
  }
};

type HistogramComponentUtils = {
  getBucket: (index: number) => RangeAggregationBucket | undefined;
  pitPoints?: number[];
  largestBucketCount: number;
  histogramStart: number;
  histogramEnd: number;
};

export const getHistogramUtils = (
  histogram: RangeAggregationHistogram | undefined
): HistogramComponentUtils => {
  if (!histogram) {
    return {
      getBucket: () => undefined,
      largestBucketCount: 0,
      histogramStart: 0,
      histogramEnd: 0,
    };
  }

  const buckets = histogram.buckets || [];
  const largestBucketCount = histogram.largestBucketCount || 0;

  return {
    getBucket: (index: number) =>
      buckets.find(({ from, to }) => index >= from && index < to),
    pitPoints: buckets.map(bucket => bucket.from),
    largestBucketCount,
    histogramStart: getHistogramStart(histogram),
    histogramEnd: getHistogramEnd(histogram),
  };
};
